import { Flex, HStack, TextProps, TooltipProps } from '@chakra-ui/react'
import { getDateString, getDateTimeString, ServerTimestamp, UserGroup } from '@hb/shared'
import React, { CSSProperties, useMemo } from 'react'
import { PreviewSpan } from './PreviewSpan'
import { UserBadge, UserBadgeProps } from './Users/UserBadge'

export const getActionLogText = (
  action?: string,
  on?: number | string | ServerTimestamp | null,
  dateStyle?: 'datetime' | 'date',
) => {
  if (on) {
    const t = `${action ? `${action} on ` : ''}${dateStyle === 'date' ? getDateString(on, 'short') : getDateTimeString(on, 'short')}`
    return t
  }
  return action
}

export const ActionLog: React.FC<{
  action?: string
  on?: number | string | ServerTimestamp | null
  by?: string | null
  color?: string
  group?: UserGroup | null
  index?: number
  notes?: string | null
  dateStyle?: 'datetime' | 'date'
  badgeProps?: Omit<UserBadgeProps, 'on' | 'userId'>
  tooltipProps?: Omit<TooltipProps, 'children'>
  style?: CSSProperties
  textProps?: TextProps
}> = ({
  action,
  on,
  by,
  color = '#4A5568',
  badgeProps,
  style,
  tooltipProps,
  group,
  dateStyle,
  notes,
  textProps,
}) => {
  const text = useMemo(() => {
    const t = getActionLogText(action, on, dateStyle)
    return (
      <PreviewSpan
        fontWeight={400}
        fontFamily="Open Sans"
        fontSize="0.9rem"
        lineHeight={1.1}
        color={color}
        {...textProps}>
        {t}
      </PreviewSpan>
    )
  }, [action, on, color, textProps, dateStyle])

  return text || by ? (
    <HStack
      spacing={1.5}
      minW="0"
      // bg={getRowBackground(index)}
      w="100%"
      style={style}>
      {by ? (
        <UserBadge
          notes={notes}
          userGroup={group}
          userId={by}
          tooltipProps={tooltipProps}
          {...badgeProps}
        />
      ) : null}
      <Flex
        flex={1}
        minW="0"
        color="inherit"
        fontSize="inherit"
        whiteSpace="nowrap"
        overflow="hidden"
        fontWeight={600}>
        {text}
      </Flex>
    </HStack>
  ) : null
}
